import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/why-typingmentor'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.WhyTypingMentorPageProps>()(Page.WhyTypingMentor)
